import * as z from "zod";

export const getDhlPickupIdConflict = {
  name: "getDhlPickupIdConflict" as const,
  input: z.object({ pickupId: z.string(), teamId: z.string() }),
  output: z.string().nullable(),
  description:
    "Get the name of another team configured with the same DHL pickup ID",
};
